import React from 'react';
import { DashboardBreadcrumbsProps } from '../types';
import {
  BreadcrumbsContainer,
  StyledParentBreadcrumb,
  StyledChildBreadcrumb,
  StyledHomeBreadcrumb
} from './styled';

const DashboardBreadcrumbs = ({
  selectedPage,
  parentCategory,
  setSelectedPage,
  closeDropdown
}: DashboardBreadcrumbsProps) => {
  const handleHomeClick = () => {
    setSelectedPage('Dashboard');
    closeDropdown();
  };

  return (
    <BreadcrumbsContainer aria-label='breadcrumb'>
      {parentCategory && (
        <StyledHomeBreadcrumb onClick={handleHomeClick}>
          Home
        </StyledHomeBreadcrumb>
      )}
      {parentCategory && (
        <StyledParentBreadcrumb>{parentCategory}</StyledParentBreadcrumb>
      )}
      {selectedPage && (
        <StyledChildBreadcrumb>{selectedPage}</StyledChildBreadcrumb>
      )}
    </BreadcrumbsContainer>
  );
};

export default DashboardBreadcrumbs;
